var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadsetMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16634 6.49967V6.33301C3.16634 3.84773 5.3303 1.83301 7.99967 1.83301C10.6691 1.83301 12.833 3.84773 12.833 6.33301V6.49967M7.99967 13.0949V13.4997C7.99967 13.8679 8.29815 14.1663 8.66634 14.1663H9.99967C11.6565 14.1663 12.9997 12.8232 12.9997 11.1663M2.83301 6.49967H3.83301V10.833H2.83301C2.28072 10.833 1.83301 10.3853 1.83301 9.83301V7.49967C1.83301 6.94739 2.28072 6.49967 2.83301 6.49967ZM12.1663 6.49967H13.1663C13.7186 6.49967 14.1663 6.94739 14.1663 7.49967V9.83301C14.1663 10.3853 13.7186 10.833 13.1663 10.833H12.1663V6.49967Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadsetMobile);
export default __webpack_public_path__ + "static/media/headset-mobile.aa4ef00055e0ea94e653f9a3a7805bb4.svg";
export { ForwardRef as ReactComponent };